import React, { useEffect } from 'react'
import useReactRouter from 'use-react-router'
import { Table, Layout, PageHeader, Popconfirm } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import notification from 'mrx-notification'
import useHeightResize from 'utils/useHeightResize'
import { Breadcrumbs } from 'components'
import * as rootStyles from 'assets/layoutStyle'
import styles from './DTGProductsList.module.scss'
import { connector, PropsFromRedux } from './container'
import CreateDTGProduct from '../CreateDTGProduct'
import { DTGProduct } from '../../types'

type HeightResizeRule = [number, number, number]
const rules: HeightResizeRule[] = [
  [0, 800, 8],
  [800, Infinity, 10]
]

const DTGProductsList = (props: PropsFromRedux) => {
  const {
    DTGProductList,
    isLoading,
    error,
    currentPage,
    total,

    changeCurrentPage,
    changePageSize,
    fetchDTGProductsList,
    removeDTGProduct
  } = props

  const { history } = useReactRouter()

  const handleChangePageSize = (newSize: number) => {
    changePageSize(newSize)
    fetchDTGProductsList()
  }

  useHeightResize(handleChangePageSize, rules)

  useEffect(() => {
    if (error) {
      notification.error({
        message: 'DTG Products list page error!',
        description: error
      })
    }
  }, [error])

  useEffect(() => {
    fetchDTGProductsList()
  }, [fetchDTGProductsList])

  const doConfirm = async (DTGProductId: number, e?: React.MouseEvent<HTMLElement>) => {
    e && e.stopPropagation()
    const isRemoved = await removeDTGProduct(DTGProductId)
    if (isRemoved) {
      notification.success({
        message: 'Successfully',
        description: 'DTG Product was deleted successfully!'
      })
    }
  }

  const columns: ColumnsType<DTGProduct> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'DTG Product ID',
      dataIndex: 'DTGProductId',
      key: 'DTGProductId'
    },
    {
      title: 'Category ID',
      dataIndex: 'categoryId',
      key: 'categoryId'
    },
    {
      title: 'Action',
      key: 'x',
      render: (_value, record) => (
        <span>
          <Popconfirm
            title='Are you sure delete this setting?'
            onConfirm={(e) => doConfirm(record.id, e)}
            onCancel={(e) => e?.stopPropagation()}
            okText='Yes'
            cancelText='No'
          >
            <a
              href='/#'
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              Remove
            </a>
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Layout style={rootStyles.root}>
      <Layout.Header style={rootStyles.header}>
        <PageHeader onBack={() => history.goBack()} title='DTG Products List' extra={[<CreateDTGProduct key='1' />]} />
      </Layout.Header>
      <Layout.Content style={rootStyles.contentBreadcrumbs}>
        <Breadcrumbs
          items={[
            { title: 'Main', url: '/' },
            { title: 'Catalogs', url: '/' },
            { title: 'DTG Products List', url: '/' }
          ]}
        />
      </Layout.Content>
      <Layout.Content className={styles.contentComponent}>
        <Table
          columns={columns}
          dataSource={DTGProductList}
          bordered
          rowKey={(record) => record.id}
          loading={isLoading}
          pagination={{
            current: currentPage,
            total,
            onChange: changeCurrentPage
          }}
        />
      </Layout.Content>
    </Layout>
  )
}

export default connector(DTGProductsList)
